import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { TosService } from '@services/tos.service';
import {environment} from '../../environments/environment'
import {Label} from '@app/localization/providers/localized-text.provider'

@Component({
  selector: 'app-tos-modal',
  templateUrl: './tos-modal.component.html',
  styleUrls: ['./tos-modal.component.scss']
})
export class TosModalComponent {
  isChecked = false;
  isSubmitting = false;
  hasSubmissionError = false;

  tosUrl = environment.termsOfServiceUrl;

  localizedLabel = Label;
  
  constructor(public tosService: TosService, private destroyRef: DestroyRef) {}

  onAgree() {
    if (!this.isChecked || this.isSubmitting) return;

    this.isSubmitting = true;
    this.hasSubmissionError = false;

    this.tosService.acceptTos().pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => this.isSubmitting = false),
    ).subscribe({
      error: (err) => {
        this.hasSubmissionError = true;
        console.error('ToS Action Failed', err);
      }
    });
  }

  onReject() {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    this.hasSubmissionError = false;
    this.tosService.rejectTos();
  }

  onRetry() {
    if (this.isSubmitting) return;

    this.tosService.retryRequests();
  }
}
